var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-card',{attrs:{"loading":_vm.isLoading}},[(_vm.companyId)?_c('v-card-text',[(_vm.companyId)?_c('ProviderList',{attrs:{"company-id":_vm.companyId,"show-search":true,"show-add":true,"show-edit":true}}):_vm._e()],1):_c('v-card-text',[_vm._v(" Şirket tedarikçilerini listelemek için üst menüden bir yönetim şirketi seçin. ")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }